import React, { useState, useEffect } from 'react';
import useReduxState from "../../../hooks/useReduxState";
import store from "src/storeWire";
import { SET_ADD_CART_DATA } from 'src/store/slice/model/Cart';
import { useCartStore } from 'src/hooks/cart';
import { useProductInventoryPriceStore } from 'src/hooks/productInventoryPrice';
import System from 'src/helper/system';
import NavigateToProductDetail from 'src/component/custom/NavigateToProductDetail';
import DisplayLongDescriptionAndVariantMFRName from 'src/component/custom/DisplayLongDescriptionAndVariantMFRName';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import Constants from 'src/helper/Constants';
import { useSystem } from "src/hooks/system";
import HelperAnalyticsEvent from 'src/support/HelperAnalyticsEvent';

const InventoryAlertForAddToCartPopup = (props) => {
    const { translation: t } = System;
    const { SetStatus } = props;
    const [productSelected, setProductSelected] = useReduxState({}, 'setAutoCompleteProductSelected')
    const [searchTerm, setSearchTerm] = useReduxState('', 'setAutoCompleteSearchTerm')
    const [{ }, { get_inventory_lead_time, get_inventory_by_id, get_pricing_by_id }, { }] = useProductInventoryPriceStore();
    const [{ }, { update_BackOrder_Quantity_ToCartServer, get_Validate_Cart_From_Server }, { ADD_TO_CART }] = useCartStore();
    const [load, SetLoad] = useState(false);
    const [{ system_alert_list }, { system_alert_indicator, remove_system_alert_indicator }, { }] = useDOMAttachToSystemStore();
    const { single_product, isFrom = false, addToCartParam, isFromManualCart = false } = props.data
    const [,{ get_quantity_format }] = useSystem();

    useEffect(() => {
        SetStatus(true)
    }, []);

    const onHide = (action = true) => {
        SetStatus(false)
        if (action) {
            store.dispatch(SET_ADD_CART_DATA(false))
        }
    };

    const onSubmit = async (e) => {
        if (load) {
            e.preventDefault();
            return false;
        }
        SetLoad(true);
        if (isFrom === Constants.systemModules.CART && isFromManualCart === false) {
            let cartDetailItems = []
            Object.entries(single_product).map(v => {
                const cart = {
                    "cartDetailId": v[1].cartDetailId,
                    "backOrderedQuantity": v[1].quantity - get_inventory_by_id(v[1].ItemNumber)?.totalInventory || 0
                }
                cartDetailItems.push(cart)
            })
            const payload = {
                "cartId": localStorage.getItem(System.getCartId()),
                "cartDetailItems": cartDetailItems
            }
            await update_BackOrder_Quantity_ToCartServer(payload)

            if (Object.keys(system_alert_list).includes('BackOrderedItem')) {
                remove_system_alert_indicator('BackOrderedItem')
            }
        } else {
            const payload = {
                ...addToCartParam,
                'isBackOrder': true
            }
            const res = await ADD_TO_CART(payload, isFrom, single_product, isFromManualCart);
            let addToCartObj = addToCartParam;
            addToCartObj = {...addToCartObj, subTotal: res?.data?.subtotal, quantity: res?.data?.backOrderedQuantity, unitPrice: res?.data?.unitPrice}
            HelperAnalyticsEvent.addToCartEvent({ productObj: addToCartObj, pricingObj: get_pricing_by_id({ ItemNumber: addToCartParam.itemNumber })?.[0], cartId: res?.data?.cartId, isFrom: isFrom });
            if (isFrom === Constants.systemModules.CART && !res?.data?.isBackOrderConfirmation) {
                get_Validate_Cart_From_Server()
            }
        }

        setProductSelected({});
        setSearchTerm('');
        SetLoad(false);
        onHide(false);
    }

    return (
        <div className="avnet-modal modal-680 inventoryalert-modal">
            <div className="avnet-modal-inner">
                {/* Modal Header */}
                <button type="button" className="close" data-dismiss="modal"
                    onClick={() => {
                        onHide()
                        if (isFrom === Constants.systemModules.CART) {
                            system_alert_indicator({
                                name: 'BackOrderedItem',
                                message: t('backOrderItemMessage'),
                                type: "danger",
                                isDisplay: false,
                                isDisplayIcon: true
                            })
                        }
                    }}>×
                </button>
                <div className="modal-header justify-content-center mt-0">
                    <h3 className="pcn-modal-heading">{t('inventoryAlert')}</h3>
                </div>
                <div className="m-4 mt-0">
                    <div className="">
                        {t('insufficientInventoryForItem')}
                    </div>
                </div>
                <div className="modal-body">
                    <div className="inventory-table">
                        <table className="table table-outline rounded-0">
                            <thead className="bg-light">
                                <tr>
                                    <th className="border-0 text-none font-12">{t('productS')}</th>
                                    <th className="border-0 text-none font-12">{t('requestedQuantity')}</th>
                                    <th className="border-0 text-none font-12">{t('backorderQuantity')}</th>
                                </tr>
                            </thead>
                            <tbody className="border-top-0">
                                {single_product.map(product => (
                                    <>
                                        <tr key={product.ItemNumber}>
                                            <td className="align-middle border-bottom-0">
                                                <div className="inventory-product-info">
                                                    <div className="inventory-product-name">
                                                        <NavigateToProductDetail data={{ ManufacturerName: product?.ManufacturerName, ERPMFRPartNumber: product?.ERPMFRPartNumber, ItemNumber: product?.ItemNumber, ERPPartNumber: product?.ERPPartNumber, seoItemNumber: product?.seoItemNumber }}>
                                                            <b className='text-black'>{product.ERPMFRPartNumber}</b>
                                                        </NavigateToProductDetail>
                                                    </div>
                                                    <div className="inventory-product-by">
                                                        <DisplayLongDescriptionAndVariantMFRName
                                                            currentProduct={{ ManufacturerName: product?.ManufacturerName, ShortDescription: product?.ShortDescription }}
                                                            inventory_alert_popup={true} />
                                                    </div>
                                                    <div className="inventory-product-stock"><b>{t('inStock')}: {get_quantity_format(get_inventory_by_id(product.ItemNumber)?.totalInventory)}</b>
                                                        {/* {get_inventory_by_id(product.ItemNumber)?.factoryStock > 0 && (

                                                        <div className="inventory-product-stock"><b>Factory Stock: {get_inventory_by_id(product.ItemNumber)?.factoryStock}</b>
                                                        </div>
                                                    )} */}
                                                    </div>
                                                    <div className="inventory-product-lead">{t('leadTimeFromSupplier:')} {get_inventory_lead_time(product?.FactoryLeadTime)}
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="align-middle">
                                            <span>{get_quantity_format(product.quantity)}</span>
                                            </td>
                                            <td className="align-middle">
                                            <span>{get_quantity_format(product.backOrderedQuantity)}</span>

                                            </td>
                                        </tr>
                                        {System.getCurrentRegionWithType(Constants.speedBoats.apacAbbr, Constants.siteUser.CORE) && (
                                            <tr>
                                                <td className="border-top-0">
                                                    <div className="reserved-inventory-box">

                                                        <div className="d-flex align-items-center justify-content-between">{t('currentStock')}
                                                            <span className="text-md-end">{get_quantity_format(get_inventory_by_id(product.ItemNumber)?.inventoryQty)}</span>
                                                        </div>
                                                        <div className="d-flex align-items-center justify-content-between">{t('reservedForYou')}
                                                            <span>{get_quantity_format(get_inventory_by_id(product.ItemNumber)?.inventory)}</span>
                                                        </div>
                                                        <div className="d-flex align-items-center justify-content-between">{t('totalAccessibleInventory')}
                                                            <span>{get_quantity_format(get_inventory_by_id(product.ItemNumber)?.totalInventory)}</span>
                                                        </div>
                                                    </div>

                                                </td>
                                            </tr>
                                        )}
                                    </>
                                ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                {/* Modal footer */}
                <div className="modal-footer justify-content-center">
                    <div className="modal-footer-actions">
                        <button type="button" className="bs5 btn btn-secondary btn-sm w145"
                            disabled={load}
                            data-bs-toggle="modal" data-bs-target="#InventoryModal"
                            onClick={() => {
                                onHide()
                                if (isFrom === Constants.systemModules.CART && isFromManualCart === false) {
                                    system_alert_indicator({
                                        name: 'BackOrderedItem',
                                        message: t('backOrderItemMessage'),
                                        type: "danger",
                                        isDisplay: false,
                                        isDisplayIcon: true
                                    })
                                }
                            }}>
                            No
                        </button>
                        <button type="button" className="bs5 btn btn-primary btn-sm w145"
                            onClick={onSubmit}>
                            {load ? <i className="fa fa-spinner fa-spin" /> : <>Yes</>}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InventoryAlertForAddToCartPopup;